import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const BuddyCSPConfig = {
  cspConfiguration: {
    partner: 'buddy',
    partnerTitle: 'Buddy Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'buddy-sit-petportal-auth.petsure.com.au',
        appClientId: '0SgZALUTOWbgDHKeZX04KA7OcPE4t9PE',
        cspMfaUrl: 'https://buddy-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-buddy-sys.petsure.com.au/account-verification'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'buddy-uat-petportal-auth.petsure.com.au',
        appClientId: 'PvXJsOzSxk5zAejuyWJrpEK93vLY1ryS',
        cspMfaUrl: 'https://buddy-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-buddy-uat.petsure.com.au/account-verification'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-preprod-auth.buddypetinsurance.com.au',
        appClientId: 'URri918PKYvRxGLUWrfhlrxUmh2Ocg3u',
        cspMfaUrl: 'https://buddy-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-portal-preprod.buddypetinsurance.com.au/account-verification'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.buddypetinsurance.com.au',
        appClientId: 'KVtETrDzjGHZhENVNId1CYfGbmAmDAm1',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://buddy-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-portal.buddypetinsurance.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'buddy.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'buddy.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'buddy.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'buddy.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: '',
      prod: ''
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/buddy-favicon.ico',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/buddy-favicon.ico'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/buddy-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/buddy-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/buddy-footer.png',
        imageTitle: 'Buddy Pet Insurance',
        imageTitleDescription: 'Buddy Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/buddy-footer.png',
        imageTitle: 'Buddy Pet Insurance',
        imageTitleDescription: 'Buddy Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: false,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Buddy - Pet Portal Login',
      description:
        'Access your Buddy Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
